/**
 * Set the current search term
 *
 * Will trigger new search
 *
 * @param searchTerm String
 * @param options Object Additional objects
 * @param autocompleteMinimumCharacters Number Only trigger autocomplete if
 * searchTerm has at least this number of characters
 * @param options.autocompleteResults Boolean Fetch autocomplete
 * results?
 * @param options.refresh Boolean Refresh search results?
 * @param options.debounce Length to debounce API calls
 */
export default function setSearchTerm(searchTerm) {
  var _console;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$autocompleteMini = _ref.autocompleteMinimumCharacters,
      autocompleteMinimumCharacters = _ref$autocompleteMini === void 0 ? 0 : _ref$autocompleteMini,
      _ref$autocompleteResu = _ref.autocompleteResults,
      autocompleteResults = _ref$autocompleteResu === void 0 ? false : _ref$autocompleteResu,
      _ref$autocompleteSugg = _ref.autocompleteSuggestions,
      autocompleteSuggestions = _ref$autocompleteSugg === void 0 ? false : _ref$autocompleteSugg,
      _ref$shouldClearFilte = _ref.shouldClearFilters,
      shouldClearFilters = _ref$shouldClearFilte === void 0 ? true : _ref$shouldClearFilte,
      _ref$refresh = _ref.refresh,
      refresh = _ref$refresh === void 0 ? true : _ref$refresh,
      _ref$debounce = _ref.debounce,
      debounce = _ref$debounce === void 0 ? 0 : _ref$debounce;

  if (this.debug) // eslint-disable-next-line no-console
    (_console = console).log.apply(_console, ["Search UI: Action", "setSearchTerm"].concat(Array.prototype.slice.call(arguments)));

  this._setState({
    searchTerm: searchTerm
  });

  if (refresh) {
    this.debounceManager.runWithDebounce(debounce, "_updateSearchResults", this._updateSearchResults, Object.assign({
      current: 1
    }, shouldClearFilters && {
      filters: []
    }));
  }

  if ((autocompleteResults || autocompleteSuggestions) && searchTerm.length >= autocompleteMinimumCharacters) {
    this.debounceManager.runWithDebounce(debounce, "_updateAutocomplete", this._updateAutocomplete, searchTerm, {
      autocompleteResults: autocompleteResults,
      autocompleteSuggestions: autocompleteSuggestions
    });
  }
}